/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const KoreaSpeceficHeader = ({
  companyRegistrationNumber,
  generalManagerName,
}) => {
  const {
    RL_GeneralManagerName, RL_CompanyRegistrationNumber
  } = useSelector((state) => state);
  return (
    <>
      {(companyRegistrationNumber) && <p>{`${RL_CompanyRegistrationNumber}: ${companyRegistrationNumber}`}</p>}
      {(generalManagerName) && <p>{`${RL_GeneralManagerName}: ${generalManagerName}`}</p>}
      {(companyRegistrationNumber || generalManagerName) && <br />}
    </>
  );
};

KoreaSpeceficHeader.defaultProps = {
  companyRegistrationNumber: '',
  generalManagerName: ''
};

KoreaSpeceficHeader.propTypes = {
  companyRegistrationNumber: PropTypes.string,
  generalManagerName: PropTypes.string
};

export default KoreaSpeceficHeader;
